module.exports = __webpack_public_path__ + "static/flags/MM-134dbe5be4783973cc4252fc487a2c1b.gif";